import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.4 28.267V3.733h10.933c3.867 0 5.682.676 6.637 1.63.954.956 1.63 2.77 1.63 6.637v16.267zm21.6 2.4H4V1.333h13.333C25.333 1.333 28 4 28 12zM12.441 18.462l.775.323.323.774c1.048 2.516 1.572 3.774 2.461 3.774s1.413-1.258 2.462-3.774l.322-.775.775-.322c2.516-1.049 3.774-1.573 3.774-2.462s-1.258-1.413-3.774-2.461l-.774-.323-.323-.775C17.413 9.925 16.889 8.667 16 8.667s-1.413 1.258-2.461 3.774l-.323.775-.775.323C9.925 14.587 8.667 15.11 8.667 16s1.258 1.413 3.774 2.462"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarOutlinedSize32Glyph.displayName = 'DocumentStarOutlinedSize32Glyph';
